import type { FC, PropsWithChildren } from "react";
import styled from "styled-components";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { useAppContext } from "src/shared/context/AppContext";
import { StyledHeadingSmallerTitleFont } from "src/website-apps/shared/components/hero-banner/ImmersiveHeroBanner/ImmersiveHeroBanner.styled";
import { isPerformerPage } from "src/website-apps/shared/utils/isPerformerPage";

const TitleVariant1 = styled(StyledHeadingSmallerTitleFont)`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title3)};

  @media ${({ theme: { media } }) => media.phone} {
    ${({
      theme: {
        typography: { getStyles, variant },
      },
    }) => getStyles(variant.title4)};
  }
`;

/**
 * Multi variate experiments 19568 & 19567 to try smaller performer name font sizes on performer page only
 */
export const SmallerPerformerFontFeature: FC<PropsWithChildren> = ({ children }) => {
  const appContext = useAppContext();
  const isMobile = !useMediaQuery(Breakpoint.Tablet);
  if (isMobile && isPerformerPage(appContext)) {
    return <TitleVariant1>{children}</TitleVariant1>;
  }
  return <StyledHeadingSmallerTitleFont>{children}</StyledHeadingSmallerTitleFont>;
};
